
export enum StatusMessageTypes {
  MicrophonePermissionNotGranted = "microphone permission not granted",
  CannotRecordOnThisPhone = "cannot record on this phone",
  RecordingFailed = "recording failed",
  NoRecordingInProgress = "no recording in progress",
  FailedToFetchRecording = "failed to fetch recording",
  RecordingInProgress = "recording in progress",
  MicrophoneIsBusy = "microphone is busy",
  RecordingStared = "recording stared"
}
